import React, { createContext, useContext, useState } from "react";
import { Dialog, DialogContent } from "../ui/dialog";
import {
  DynamicEmbeddedWidget,
  useDynamicContext,
} from "@dynamic-labs/sdk-react-core";
import { Loader2Icon } from "lucide-react";

export const AuthContext = createContext({
  showAuth: false,
  handleShowAuth: () => {},
  handleLogOut: () => {},

  user: null,
});

export const AuthProvider = ({ children }) => {
  const [showAuth, setShowAuth] = useState(false);
  const { handleLogOut: handleLogOutDynamic, user } = useDynamicContext();

  const handleShowAuth = (value) => {
    setShowAuth(value);
  };

  const handleLogOut = () => {
    handleLogOutDynamic();
  };

  return (
    <AuthContext.Provider
      value={{ showAuth, handleShowAuth, user: user || null, handleLogOut }}
    >
      {children}

      <Dialog open={showAuth} onOpenChange={handleShowAuth}>
        <DialogContent className="p-0 md:max-w-[400px]">
          {!user && <DynamicEmbeddedWidget />}
          {user && (
            <div className="min-h-[300px] flex flex-col">
              <div className="flex-1 flex items-center justify-center gap-3 flex-col p-6">
                <Loader2Icon className="size-6 animate-spin text-primary" />
                <p className="animate-pulse">Redirecting...</p>
              </div>

              <div className="pb-3 w-full flex justify-center">
                <button
                  className="underline text-foreground-800 text-sm text-center"
                  onClick={handleLogOut}
                >
                  Logout
                </button>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }

  return context;
};
